export const OCCASION_TONE = {
  birthday: "birthday",
  wedding: "wedding",
  anniv: "anniversary",
  jubilee: "anniversary",
  confession: "proposal",
  thanks: "gratitude",
  support: "support",
  army: "support",
};

export function occasionTone(key) {
  return OCCASION_TONE[key] || "other";
}

export const EVENTS = [
  { key: "birthday", label: "День народження" },
  { key: "confession", label: "Освідчення" },
  { key: "wedding", label: "Весілля" },
  { key: "jubilee", label: "Ювілей" },
  { key: "thanks", label: "Подяка" },
  { key: "army", label: "Військовому" },
  { key: "baby", label: "Для малюка" },
  { key: "graduation", label: "Випускний" },
  { key: "nooccasion", label: "Без приводу" },
  { key: "custom", label: "Своя тема" },
  { key: "anniv", label: "Річниця" },
  { key: "christening", label: "Хрестини" },
  { key: "newyear", label: "Новий рік" },
  { key: "support", label: "Підтримка" },
  { key: "sorry", label: "Вибачення" },
  { key: "prank", label: "Розіграш" },
];

export const HOME_EVENTS = ["custom", "birthday", "jubilee", "army", "baby", "anniv"];

export const CONSTRUCTOR_ORDER = [
  "custom", "nooccasion",
  "birthday", "jubilee", "wedding", "anniv", "confession", "thanks",
  "army", "support", "christening", "baby", "graduation", "newyear", "sorry", "prank",
];

export const SOUND_KEYS = ["guitar", "pop", "rnb", "dance", "zastilna", "lightrock", "rock", "rap", "deephouse", "disney"];
export const SOUND_ICONS = ["🪕", "🎤", "🎷", "💃", "🥂", "🎸", "🤘", "🎧", "🌊", "🏰"];

export const GENRE_SHORT = {
  guitar: "Лірика",
  pop: "Поп",
  rnb: "R&B",
  dance: "Танцювальна",
  zastilna: "Застільна",
  lightrock: "Легкий рок",
  rock: "Рок",
  rap: "Реп",
  deephouse: "Діп-хаус",
  disney: "Дісней",
  mix: "Мікс",
  custom: "Свій стиль",
};

export const PRICE_PER_SONG = 169;
export const REGEN_PRICE = 30;

const CID_KEY = "episnya_client_id";

export function getClientId() {
  try {
    let id = localStorage.getItem(CID_KEY);
    if (!id) {
      id = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(CID_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}

export function getTgUser() {
  try {
    return window.Telegram?.WebApp?.initDataUnsafe?.user || null;
  } catch {
    return null;
  }
}

export function trackApp(event, detail) {
  try {
    const u = getTgUser();
    const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${API_BASE}/api/public/app/click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        detail: detail || "",
        tg_id: u?.id || null,
        client_id: getClientId(),
        init_data: window.Telegram?.WebApp?.initData || null,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* noop */ }
}

export function trackAppEnter() {
  try {
    const u = getTgUser();
    if (!u?.id) return;
    const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${API_BASE}/api/public/app/enter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tg_id: u.id,
        username: u.username || null,
        first_name: u.first_name || null,
        last_name: u.last_name || null,
        language_code: u.language_code || null,
        client_id: getClientId(),
        init_data: window.Telegram?.WebApp?.initData || null,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* noop */ }
}

export function tgContact(user) {
  if (!user) return "";
  if (user.username) return "@" + user.username;
  return user.first_name || "";
}

export function stripEmoji(text) {
  return String(text || "").replace(/^[^\p{L}\p{N}]+/u, "").trim();
}

export function songWord(n) {
  const v = Number(n) || 0;
  if (v % 10 === 1 && v % 100 !== 11) return "пісня";
  if (v % 10 >= 2 && v % 10 <= 4 && (v % 100 < 10 || v % 100 >= 20)) return "пісні";
  return "пісень";
}

const STATUS_MAP = {
  unpaid: { label: "очікує оплати", color: "#FFD34D", border: "rgba(255,211,77,.35)", bg: "rgba(255,211,77,.10)" },
  created: { label: "перевірка оплати", color: "#5AA9FF", border: "rgba(90,169,255,.35)", bg: "rgba(47,128,255,.10)" },
  screenshot_wait: { label: "перевірка оплати", color: "#5AA9FF", border: "rgba(90,169,255,.35)", bg: "rgba(47,128,255,.10)" },
  pending: { label: "перевірка оплати", color: "#5AA9FF", border: "rgba(90,169,255,.35)", bg: "rgba(47,128,255,.10)" },
  paid: { label: "виконується студією", color: "#29B6FF", border: "rgba(41,182,255,.35)", bg: "rgba(41,182,255,.10)" },
  done: { label: "виконано", color: "#5AA9FF", border: "rgba(90,169,255,.35)", bg: "rgba(47,128,255,.10)" },
  expired: { label: "прострочено", color: "#7F8BA0", border: "rgba(255,255,255,.12)", bg: "rgba(255,255,255,.05)" },
  rejected: { label: "відхилено", color: "#FF5C67", border: "rgba(255,92,103,.35)", bg: "rgba(255,92,103,.10)" },
};

export function statusOf(status) {
  return STATUS_MAP[status] || { label: status || "—", color: "#8A9ABB", border: "rgba(255,255,255,.12)", bg: "rgba(255,255,255,.05)" };
}

const GROUP_STYLE = {
  unpaid: { color: "#FFD34D", border: "rgba(255,211,77,.35)", bg: "rgba(255,211,77,.10)" },
  review: { color: "#5AA9FF", border: "rgba(90,169,255,.35)", bg: "rgba(47,128,255,.10)" },
  paid: { color: "#29B6FF", border: "rgba(41,182,255,.35)", bg: "rgba(41,182,255,.10)" },
  generating: { color: "#29B6FF", border: "rgba(41,182,255,.35)", bg: "rgba(41,182,255,.10)" },
  done: { color: "#4ADE80", border: "rgba(74,222,128,.35)", bg: "rgba(74,222,128,.10)" },
  rejected: { color: "#FF5C67", border: "rgba(255,92,103,.35)", bg: "rgba(255,92,103,.10)" },
  expired: { color: "#7F8BA0", border: "rgba(255,255,255,.12)", bg: "rgba(255,255,255,.05)" },
};

export function statusMeta(item) {
  if (item && typeof item === "object" && item.status_group) {
    const s = GROUP_STYLE[item.status_group] || GROUP_STYLE.review;
    return { label: item.status_label || item.status || "—", ...s };
  }
  return statusOf(typeof item === "object" ? item?.status : item);
}

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtDuration(value) {
  const sec = Number(value);
  if (!Number.isFinite(sec) || sec <= 0) return "";
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function listenUrlOf(item) {
  const raw = item?.listen_url || "";
  if (!raw) return "";
  return raw.startsWith("http") ? raw : `${window.location.origin}${raw}`;
}
